// UI
import ResponsiveTitle from './ResponsiveTitle'

export default ResponsiveTitle